<template>
  <div class="products-result-base" :style="styles">
    <img :src="`${path}somari_line01.png`" alt="">
    <h1> <img :src="`${path}title_3nen.png`" alt="" class="block-three-year__headline-img" /></h1>

    <div class="lead-area">

      <img class="lead-area-img" :src="iconImages.image1" alt="">
      <p class="lead-area-text">あなたが今どんな運気の中にいるのかは、昨年からの流れを追うと分かります。<br>
        来年までの3年間の運気の動きを見てみましょう。
      </p>
    </div>



    <div class="year-list">
      <ul class="year-list_ul">
        <li class="year-list_li">
          <span class="year-list_when"><img class="year-list_whenimg" :src="`${path}title_lastyear.png`" alt=""></span>
          <span class="year-list_text"  v-html="tgtResult.lastyear"></span>
        </li>
        <li class="year-list_li">
          <span class="year-list_when"><img class="year-list_whenimg" :src="`${path}title_thisyear.png`" alt=""></span>
          <span class="year-list_text"  v-html="tgtResult.thisyear"></span>
        </li>
        <li class="year-list_li">
          <span class="year-list_when"><img class="year-list_whenimg" :src="`${path}title_nextyear.png`" alt=""></span>
          <span class="year-list_text"  v-html="tgtResult.nextyear"></span>
        </li>

      </ul>
    </div>
    <img :src="`${path}somari_line02.png`" alt="" class="endline">
    <!--
    <div class="more-info">
      <div class="more-info-textbox">
        <img :src="`${path}title_moreinfo.svg`" alt="">
        <a href="/tag/448">
        <span class="baseButton__button baseButton__button--fill"><span class="baseButton__button__label">こちらをチェック</span></span>
        </a>
      </div>
      <img class="more-info-img" :src="iconImages.image2" alt="">
    </div>
    -->
    <recommend-block-plus
      :recommend-data="standardRecommendData"
      :color-scheme="recommendColorScheme"
    />

  </div>
</template>

<script>
import {BASIC_DATA, DEFAULT_FOOTER_MENULIST } from '@/utvStore/components/recommend/lp/commons'
import moment from "moment";
import * as type from '@/utvStore/store/mutation-types'

import RecommendBlockPlus from '@/utvStore/components/common/RecommendBlockPlus'

export default {
  name: 'ProductsResult01',
  components: {
    RecommendBlockPlus,
  },
  props: {
    resultData: {
      type: Object,
      default: null,
    },
    requireProf: {
      type: Array,
      default: null,
    },
    standardRecommendData: {
      type: Array,
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
  },
  data(){
    return {
      path: '/static/img/recommend/lp/somarimone/products/',
    }
  },
  computed: {
    iconImages() {
      if(!!this.resultData.images) {
        return this.resultData.images
      }
    },
    tgtResult() {
      if(!!this.resultData.results) {
        return {
          lastyear: this.resultData.results.text1,
          thisyear: this.resultData.results.text2,
          nextyear: this.resultData.results.text3,
        }
      }
    },
    counselorInfos(){
      return BASIC_DATA.somarimone
    },
    recommendColorScheme() {
      return {
        keyColor: this.counselorInfos.colorScheme.keyColor,
      }
    },
    styles() {
      return {
        '--key-color': this.counselorInfos.colorScheme.keyColor,
        '--second': this.counselorInfos.colorScheme.second,
        '--grad-start': this.counselorInfos.colorScheme.gradStart,
        '--grad-end': this.counselorInfos.colorScheme.gradEnd,
        '--mess-bg': this.counselorInfos.colorScheme.messBg,
      };
    },
  },
  created() {
    this.$store.dispatch(type.SET_COLOR_SCHEME, this.counselorInfos.colorScheme)
  },
  mounted() {
    console.log('  下層resultData:%O', this.resultData)
  },
  methods: {
  },
}</script>

<style scoped lang='scss'>
@import "../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

/deep/ {
  img {
    max-width: 100%;
    display: block;
  }
  p {
    margin: 0 auto 24px;
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
}
.products-result-base {
  background: #fcece1;
  background-size: 100% auto;
  //padding-top: 40px;
  padding-top: 0px;
  h1 {
    margin: 24px auto 24px;
  }
  .result-base {
    background: white;
    width: calc(100% - 36px);
    margin: 0 auto 24px;
    padding: 15px;
    padding-bottom: 24px;

    border-radius: 10px;
    margin-bottom: 60px;
    h1 {
      margin: 0;
      padding-top: 40px;
    }
    h2{
      font-weight: 600;
      font-size: 18px;
      line-height: 24px;
      text-align: center;

      margin: 16px 0 24px;
      .pre-word {
        display: block;
        font-size: 0.8em;
      }
    }
    h4{
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 16px;

      margin: 0;
      margin-bottom: 8px;
    }
  }
  .year-list {
    padding: 0 20px;
    margin-bottom: 24px;
}
  .year-list_ul{

  }
  .year-list_li{
    border: 1px solid $l_col_keycolor;
    overflow: hidden;

    //background: #fff;
    background: #fefaf0;
    min-height: 100px;
    display: flex;
    align-items: center;
    border-bottom: none;
    &:first-child{
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
    }
    &:last-child{
      border-bottom:1px solid $l_col_keycolor ;
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;
    }
  }
  .year-list_when{
   background: #fefaf0;
   //padding: 40px 0;
   min-width: 40px;
  }
  .year-list_whenimg{
    width: 36px;
  }

  .year-list_text{
    background: #fff;
    max-width: 355px;
    padding: 16px;
    @include mq('w580'){
      max-width: 100%;
    }
  }
  .lead-area {
    display: flex;
    padding: 0 20px;
    margin-bottom: 24px;
  }
  .lead-area-text {
    color: #32373F;
    font-size: 14px;
    line-height: 21px;
    /* margin-right: 16px; */
  }
  .lead-area-img {
    border-radius: 100px;
    width: 133px;
    height: 133px;
    margin-right: 16px;
  }
  .more-info {
    display: flex;
    padding: 0 20px;
    background: #FEFAF0;
    padding-top: 59px;
    padding-bottom: 45px;
    align-items: center;
    justify-content: center;

  }
  .more-info-img {
    width: 133px;
    height: 133px;
    border-radius: 100px;
  }
  .more-info-textbox {
    margin-right: 16px;
  }
  .endline{
    margin-bottom: -32px;
  }
  .baseButton__button {
    width: 100%;
    max-width: 186px;
    display: inline-block;
    font-weight: 700;
    font-size: 11px;
    color: white;
    text-decoration: none;
    padding: 16px 32px;
    border-radius: 50px;
    cursor: pointer;
    position: relative;
    z-index: 1;
    background: linear-gradient(86.51deg, $l_col_grad_start 21.4%, $l_col_grad_end 76.64%);
    text-align: center;
    margin-top: 14px;
    position: relative;
    &:after{
      content:'▼';
      position: absolute;
      transform: rotate(30deg);
      top: 17px;
      right: 9%;

    }
    @include mq('w320'){
      font-size: 14px;
    }
  }
  .baseButton__button__label {
    margin-left: -21px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/somarimone/fortunes/ProductsResult01.vue